<template>
  <div>
    <p v-if="showTitle" class="title">Hdd</p>
    <div v-for="storage in storages" :key="storage.title">
      <span class="subtitle" :key="storage.title">{{storage.title}} - {{storage.inUse}}/{{storage.storage}}</span>
      <progress class="progress is-success" :class="{'is-warning': storage.percent.replace('%', '')>50}" :value="storage.percent.replace('%', '')" max="100">{{storage.percent}}</progress>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      storages: []
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "hdd.php")
        .then(response => {
          this.storages = response.data;

          setTimeout(() => {
            this.startMonitor();
          }, 30000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    }
  }
};
</script>

<style scoped>
.subtitle {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorHdd.vue